import { usePage } from "PFApp/use_page";
import { useEffect, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

const useBookingPage = (initPage) => {
  const history = useHistory();
  const { search } = useLocation();
  const { page, mergePage, setPage, resetPage } = usePage(`booking`, initPage);

  const tab = useMemo(
    () => initPage.tab || window.storage.getItem("previous_booking_section") || "overview",
    []
  );

  useEffect(() => {
    history.replace(`/booking/${tab}${search}`);
  }, []);

  const changeTab = (newTab, initialTabData) => {
    history.push(`/booking/${newTab}`);
    window.storage.setItem("previous_booking_section", newTab);
    mergePage({ tab: newTab, initialTabData });
  };

  useEffect(() => {
    setPage({
      ...initPage,
      tab,
      changeTab,
      initialized: true
    });
    return resetPage;
  }, []);

  return page;
};

export default useBookingPage;
